// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.services__container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-x: hidden; /* Empêche le débordement horizontal */
  min-height: 400px; /* Assure une hauteur minimale pour le carousel */
  padding: 2rem 0; /* Ajoute un peu d'espace vertical */
}

.card.services {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.service__icon {
  background: var(--color-primary);
  padding: 0.6rem;
  border-radius: var(--border-radius-3);
  font-size: 1.5rem;
  color: var(--color-white);
  transition: var(--transition);
}

.service:hover .service__icon {
  background: var(--color-light);
  color: var(--color-primary);
}

.service h4 {
  margin-bottom: 0.4rem;
}

/* Media queries tablets */

@media screen and (max-width: 1024px) {
  .services__container {
    gap: 1.5rem;
  }
}

/* Media queries phones */

@media screen and (max-width: 600px) {
  .services__container {
    grid-template-columns: 1fr;
    gap: 1.2rem;
  }

  .card.service {
    gap: 1.2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/services/services.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB,EAAE,sCAAsC;EAC1D,iBAAiB,EAAE,iDAAiD;EACpE,eAAe,EAAE,oCAAoC;AACvD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,qCAAqC;EACrC,iBAAiB;EACjB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,0BAA0B;;AAE1B;EACE;IACE,WAAW;EACb;AACF;;AAEA,yBAAyB;;AAEzB;EACE;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".services__container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow-x: hidden; /* Empêche le débordement horizontal */\n  min-height: 400px; /* Assure une hauteur minimale pour le carousel */\n  padding: 2rem 0; /* Ajoute un peu d'espace vertical */\n}\n\n.card.services {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n}\n\n.service__icon {\n  background: var(--color-primary);\n  padding: 0.6rem;\n  border-radius: var(--border-radius-3);\n  font-size: 1.5rem;\n  color: var(--color-white);\n  transition: var(--transition);\n}\n\n.service:hover .service__icon {\n  background: var(--color-light);\n  color: var(--color-primary);\n}\n\n.service h4 {\n  margin-bottom: 0.4rem;\n}\n\n/* Media queries tablets */\n\n@media screen and (max-width: 1024px) {\n  .services__container {\n    gap: 1.5rem;\n  }\n}\n\n/* Media queries phones */\n\n@media screen and (max-width: 600px) {\n  .services__container {\n    grid-template-columns: 1fr;\n    gap: 1.2rem;\n  }\n\n  .card.service {\n    gap: 1.2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
